import { defineComponent as _defineComponent } from 'vue'
import { vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "width_wrap" }
const _hoisted_3 = { class: "body_content sub" }
const _hoisted_4 = {
  key: 0,
  class: "loading-indicator",
  style: {"text-align":"center","padding":"20px"}
}
const _hoisted_5 = {
  key: 1,
  class: "error-message",
  style: {"text-align":"center","padding":"20px","color":"red"}
}
const _hoisted_6 = {
  key: 2,
  class: "glores-B-list-type1"
}
const _hoisted_7 = { key: 1 }
const _hoisted_8 = {
  key: 3,
  class: "pagination-controls",
  style: {"margin-top":"15px","text-align":"center"}
}
const _hoisted_9 = { style: {"margin":"0 10px"} }

import { ref, onMounted, h, computed, watch } from "vue";
import MyPageSidebar from "@/views/member/MypageSidebar.vue";
import Banner from "@/components/Banner.vue";
import { USER_ROUTES } from "@/assets/route_constants.ts";
import {
  NDataTable,
  NButton,
  NSpace,
  useMessage,
  NModal,
  NDescriptions,
  NDescriptionsItem,
  NCard,
} from "naive-ui";
import Loading from "@/components/Loading.vue";
import { getCallable, makeCallApiParam } from "@/config/env";
import * as common from "@/assets/common/common";
import * as constant from "@/constants/constant";
import { useRouter } from "vue-router"; // getOrderStatusString removed as it's replaced by graphical steps
import { Order } from "@/model/order";
import { useAuth } from "@/composables/useAuth";
import { useAlertDialog } from "@/composables/useAlert";
import { usePagination } from "@/composables/usePagination";

const getMyOrders = "getMyOrders";
const pageSize = 10; // 페이지 크기를 상수로 정의


export default /*@__PURE__*/_defineComponent({
  __name: 'OrgOrder',
  setup(__props) {

const useAlert = useAlertDialog();
const { isLoggedIn } = useAuth();
const message = useMessage();
const router = useRouter();
const getCallApiCallable = getCallable("callApi");
const searchQuery = ref(""); // 검색어 상태 추가
const pageLoading = ref(false);
// const listLoading = ref(false);
// const error = ref<string | null>(null);
// const orders = ref<Order[]>([]);

const showOrderDetailModal = ref(false);
const selectedOrderDetail = ref<Order | null>(null);

const {
  paginatedItems: orders,
  listLoading,
  error,
  currentPage,
  hasNextPage,
  goToNextPage: composableGoToNextPage,
  goToPreviousPage: composableGoToPreviousPage,
  refreshData: composableRefreshItems, // Renamed for clarity
} = usePagination<Order, { searchKey?: string; searchValue?: string }>(
  async (params) =>
    getCallApiCallable(
      makeCallApiParam(getMyOrders, {
        ...params,
        searchKey: "title",
        searchValue: searchQuery.value,
        type: constant.orderType.BODY,
      })
    ),
  pageSize
);

watch(
  isLoggedIn,
  async (newValue) => {
    if (newValue === false) {
      await useAlert("회원전용 페이지 입니다. 로그인 후 이용해주세요.");
      // TODO : 단순히 뒤로 갈지 향후 확인 후 변경 가능.
      // router.back();
      router.push({ name: USER_ROUTES.Home.Name });
    }
  },
  { immediate: true }
);

const statusSteps = [
  {
    key: "register_pending",
    label: "진단정보 등록대기",
    statuses: [
      constant.orderStatus.APPROVED,
      constant.orderStatus.APPROVED_TEMP_SAVE,
    ],
    iconText: "1",
    color: "#66BB6A", // 녹색 (Green)
  },
  {
    key: "start_pending",
    label: "진단시작 대기",
    statuses: [constant.orderStatus.READY],
    iconText: "2",
    color: "#26A69A", // 청록색 (Teal)
  },
  {
    key: "in_progress",
    label: "진단 진행중",
    statuses: [constant.orderStatus.ING],
    iconText: "3",
    color: "#42A5F5", // 파란색 (Blue)
  },
  {
    key: "completed",
    label: "진단 완료",
    statuses: [constant.orderStatus.COMPLETED],
    iconText: "4",
    color: "#5C6BC0", // 남색 (Indigo)
  },
];

const columns = computed(() => [
  {
    title: "견적명",
    key: "name",
    ellipsis: { tooltip: true },
    titleAlign: "center",
    align: "left",
  },
  {
    title: "신청일",
    key: "createdDate",
    titleAlign: "center",
    align: "center",
    width: 120,
    render: (row: Order) =>
      common.getYYYYMMDD2(new Date(Number(row.createdDate))), // formatDate 함수 필요
  },
  {
    title: "진행상태",
    key: "progressManagementGroup",
    titleAlign: "center",
    children: [
      {
        title: "",
        key: "status",
        titleAlign: "center",
        align: "center",
        width: 300,
        render: (row: Order) => {
          if (!hasSurvey(row)) {
            return h("span", "해당없음");
          }

          let actualCurrentStepIndex = -1;
          statusSteps.forEach((step, index) => {
            if (step.statuses.includes(row.status)) {
              actualCurrentStepIndex = index;
            }
          });

          const stepNodes: any[] = [];
          statusSteps.forEach((step, index) => {
            let stepClass = "pending";
            let iconStyle = {};
            let labelStyle = {};

            if (index < actualCurrentStepIndex) {
              // Completed step
              stepClass = "completed";
              iconStyle = {
                borderColor: step.color,
                backgroundColor: step.color,
                color: "white",
              };
              labelStyle = { color: step.color };
            } else if (index === actualCurrentStepIndex) {
              // Current step
              stepClass = "current";
              iconStyle = {
                borderColor: step.color,
                backgroundColor: step.color,
                color: "white",
              };
              labelStyle = { color: step.color, fontWeight: "bold" };
            }

            stepNodes.push(
              h("div", { class: `step-item ${stepClass}` }, [
                h(
                  "div",
                  { class: "step-icon-container", style: iconStyle },
                  step.iconText
                ),
                h(
                  "div",
                  { class: "step-label", style: labelStyle },
                  step.label
                ),
              ])
            );

            if (index < statusSteps.length - 1) {
              const connectorClass =
                index < actualCurrentStepIndex ? "completed" : "pending";
              const connectorStyle =
                index < actualCurrentStepIndex
                  ? { backgroundColor: step.color }
                  : {};
              stepNodes.push(
                h("div", {
                  class: `step-connector ${connectorClass}`,
                  style: connectorStyle,
                })
              );
            }
          });
          return h("div", { class: "status-stepper" }, stepNodes);
        },
      },
      {
        title: "", // 하위 헤더 텍스트를 빈 문자열로 설정하여 숨김
        key: "actions",
        width: 150,
        titleAlign: "center",
        align: "center",
        render(row: Order) {
          const buttons: any = [];
          const hasSurveyItem = hasSurvey(row);

          if (hasSurveyItem) {
            const currentStep = statusSteps.find((step) =>
              step.statuses.includes(row.status)
            );
            const buttonColor = currentStep ? currentStep.color : undefined;

            if (
              row.status === constant.orderStatus.APPROVED ||
              row.status === constant.orderStatus.APPROVED_TEMP_SAVE
            ) {
              buttons.push(
                h(
                  NButton,
                  {
                    size: "small",
                    color: buttonColor,
                    onClick: () => gotoOrderProject(row.SK),
                  },
                  { default: () => "진단정보 등록" }
                )
              );
            } else if (row.status === constant.orderStatus.READY) {
              buttons.push(
                h(
                  NButton,
                  {
                    size: "small",
                    color: buttonColor,
                    onClick: () => gotoOrderProjectDetail(row.SK),
                  },
                  { default: () => "진단정보 확인" }
                )
              );
            } else if (row.status === constant.orderStatus.ING) {
              buttons.push(
                h(
                  NButton,
                  {
                    size: "small",
                    color: buttonColor,
                    onClick: () => gotoOrderProjectDetail(row.SK),
                  },
                  { default: () => "진단현황 확인" }
                )
              );
            } else if (row.status === constant.orderStatus.COMPLETED) {
              buttons.push(
                h(
                  NButton,
                  {
                    size: "small",
                    color: buttonColor,
                    onClick: () => gotoOrderProjectDetail(row.SK),
                  },
                  { default: () => "진단결과 조회" }
                )
              );
            }
          }

          return h(NSpace, { justify: "center" }, () => buttons);
        },
      },
    ],
  },
]);

async function wrappedRefreshItems() {
  await composableRefreshItems();
}

async function wrappedGoToNextPage() {
  if (hasNextPage.value) {
    await composableGoToNextPage();
  }
}

async function wrappedGoToPreviousPage() {
  if (currentPage.value > 1) {
    await composableGoToPreviousPage();
  }
}

function hasSurvey(order: Order) {
  let hasSurveyItem = false;
  for (let product in order.products) {
    if (
      order.products[product].type?.startsWith("putt_") ||
      order.products[product].type?.startsWith("tocc_") ||
      order.products[product].type?.startsWith("tec")
    ) {
      hasSurveyItem = true;
      break;
    }
  }
  return hasSurveyItem;
}

// async function fetchUserOrders() {
//     listLoading.value = true;
//     error.value = null;
//     try {
//         const result = await getUserOrdersCallable({ type: constant.orderType.BODY });
//         orders.value = common.getItemListFromFunctionResult(result) as Order[];
//     } catch (err: any) {
//         console.error("사용자 견적 목록 로딩 실패:", err);
//         error.value = "견적 목록을 불러오는데 실패했습니다.";
//         orders.value = [];
//     } finally {
//         listLoading.value = false;
//     }
// }

function viewOrderDetails(order: Order) {
  selectedOrderDetail.value = order;
  showOrderDetailModal.value = true;
}

function gotoOrderProject(orderSK: string) {
  router.push({
    name: USER_ROUTES.Mypage.Order.Org.Project.Name,
    params: { SK: orderSK },
  });
}

function gotoOrderProjectDetail(orderSK: string) {
  router.push({
    name: USER_ROUTES.Mypage.Order.Org.Project.Detail.Name,
    params: { SK: orderSK },
  });
}

onMounted(() => {
  wrappedRefreshItems();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createVNode(Loading, null, null, 512), [
      [_vShow, pageLoading.value]
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(MyPageSidebar),
      _createElementVNode("div", _hoisted_3, [
        _cache[3] || (_cache[3] = _createElementVNode("h1", { class: "sub_subject" }, [
          _createTextVNode("진단검사"),
          _createElementVNode("span")
        ], -1)),
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "glores-B-list-h2" }, [
          _createElementVNode("div", { class: "h-left" })
        ], -1)),
        (_unref(listLoading))
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, " 진단 검사 목록을 불러오는 중... "))
          : _createCommentVNode("", true),
        (_unref(error))
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_unref(error)), 1))
          : _createCommentVNode("", true),
        (!_unref(listLoading) && !_unref(error))
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              (_unref(orders).length > 0)
                ? (_openBlock(), _createBlock(_unref(NDataTable), {
                    key: 0,
                    class: "org-order-table",
                    columns: columns.value,
                    data: _unref(orders),
                    pagination: false,
                    bordered: false,
                    "single-line": false
                  }, null, 8, ["columns", "data"]))
                : (_openBlock(), _createElementBlock("ul", _hoisted_7, _cache[0] || (_cache[0] = [
                    _createElementVNode("li", { class: "none-data" }, "등록된 견적이 없습니다.", -1)
                  ])))
            ]))
          : _createCommentVNode("", true),
        (_unref(orders).length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createVNode(_unref(NButton), {
                onClick: wrappedGoToPreviousPage,
                disabled: _unref(currentPage) === 1,
                style: {"margin-right":"8px"}
              }, {
                default: _withCtx(() => _cache[1] || (_cache[1] = [
                  _createTextVNode(" 이전 페이지 ")
                ])),
                _: 1
              }, 8, ["disabled"]),
              _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(currentPage)) + " 페이지", 1),
              _createVNode(_unref(NButton), {
                onClick: wrappedGoToNextPage,
                disabled: !_unref(hasNextPage)
              }, {
                default: _withCtx(() => _cache[2] || (_cache[2] = [
                  _createTextVNode(" 다음 페이지 ")
                ])),
                _: 1
              }, 8, ["disabled"])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})